import { useSelector } from 'react-redux';

import { Box } from '@interstate/components/Box';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { FINANCE } from '@makemydeal/dr-platform-types';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { CALCULATED_PAYMENTS_DISCLAIMER } from '../../constants';

const textForFinance = `The additional payments shown are estimates, please adjust rates if needed. All payments are based on the same protection products, accessories and conditional rebates.`;
const textForLease = `All payments are based on the same protection products, accessories and conditional rebates.`;

/**
 * Disclaimer under the grid's editable rows. Lives outside SellRates so rows added below it — the Lease
 * residual row — still render above the note.
 */
const PaymentGridNote = () => {
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isDealCentralExperience = useSelector(dealerSelectors.isDealCentralExperience);
    const isExplicitLenderP1Enabled = useSelector(featureToggleSelectors.isExplicitLenderP1Enabled);

    if (isDealCentralExperience) {
        return null;
    }

    return (
        <Box flex="auto" padding="1rem 0">
            {isExplicitLenderP1Enabled ? CALCULATED_PAYMENTS_DISCLAIMER : offerType === FINANCE ? textForFinance : textForLease}
        </Box>
    );
};

export default PaymentGridNote;
